import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, LogOut } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 glass border-b border-black/5">
      <nav className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2 font-heading text-xl text-charcoal"
        >
          <Sparkles className="w-5 h-5 text-primary-c" strokeWidth={2} style={{ color: "var(--primary)" }} />
          20 Year Self
        </Link>
        <div className="flex items-center gap-2 sm:gap-5">
          {user ? (
            <>
              <Link
                to="/create"
                data-testid="nav-create"
                className="text-sm font-semibold text-charcoal hover:text-[var(--primary)] transition-colors"
              >
                New Glow-Up
              </Link>
              <Link
                to="/history"
                data-testid="nav-history"
                className="text-sm font-semibold text-charcoal hover:text-[var(--primary)] transition-colors"
              >
                History
              </Link>
              <button
                data-testid="nav-logout"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="flex items-center gap-1.5 text-sm font-semibold text-muted-c hover:text-charcoal transition-colors"
              >
                <LogOut className="w-4 h-4" /> {user.username}
              </button>
            </>
          ) : (
            <Link
              to="/login"
              data-testid="nav-login"
              className="btn-primary px-5 py-2 text-sm font-semibold"
            >
              Login
            </Link>
          )}
        </div>
      </nav>
    </header>
  );
};
